const InnerCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
    className={'inner'}
  >
    <circle cx="11" cy="11" r="11" fill="#999"></circle>
  </svg>
);

export default InnerCircle;
